<template>
  <div v-if="!loading">
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span v-if="panel === 'FICHE_LOT'" slot="left-title">{{program.name | cap}} - Création d'un lot</span>
      <span slot="left-title" v-if="panel === 'FICHE_PARKING'">{{program.name | cap}} - Création d'un parking</span>
      <span v-if="panel === 'IMPORT'" slot="left-title">Création automatique de lots</span>
    </sticky>
    <div>
      <div class="columns is-padding-left-on-btn-actions has-stickyColumn has-stickyColumn--left">
        <div class="column is-3 is-2-fullhd is-paddingless-left is-paddingless-right">
          <div class="is-border has-bg-white">
            <aside class="menu menu-admin">
              <ul class="menu-list">
                <li :class="{'is-active' : panel === 'FICHE_LOT'}">
                  <a @click="panel = 'FICHE_LOT'">Fiche lot</a>
                </li>
                <li :class="{'is-active' : panel === 'IMPORT'}">
                  <a @click="panel = 'IMPORT'">Import automatique</a>
                </li>
                <li :class="{'is-active' : panel === 'FICHE_PARKING'}">
                  <a @click="panel = 'FICHE_PARKING'">Fiche parking</a>
                </li>
              </ul>
            </aside>
          </div>
        </div>
        <div class="column">
          <div v-show="panel === 'FICHE_LOT'">
            <lot-create :source="program"></lot-create>
          </div>
          <div v-show="panel === 'IMPORT'">
            <program-lots-import-modal></program-lots-import-modal>
          </div>
          <div v-show="panel === 'FICHE_PARKING'">
            <parking-create :source="program"></parking-create>
          </div>
        </div>
      </div>
    </div>
  </div>
  <spinner-round :isLoading="loading" v-else></spinner-round>
</template>

<script>
  import LotCreate from '../lot/LotCreate'
  import ParkingCreate from '../parking/ParkingCreate'
  import ProgramLotsImportModal from './ProgramLotsImportModal'

  export default {
    name: 'ProgramChild',
    components: { LotCreate, ParkingCreate, ProgramLotsImportModal },
    data () {
      return {
        panel: 'FICHE_LOT',
        program: null,
        loading: true
      }
    },
    computed: {
      pk () {
        return this.$route.params.id
      }
    },
    methods: {
      getProgram (programPk) {
        this.$api.programService.getOne(programPk).then(r => {
          this.program = r.data
          this.loading = false
        })
      }
    },
    created () {
      if (this.$route.params.id) {
        this.getProgram(this.$route.params.id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/ProgramChild.vue